import { classNames } from "@ember-decorators/component";
import MultiSelectComponent from "select-kit/components/multi-select";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const GroupChooser = dt7948.c(class GroupChooser extends MultiSelectComponent {}, [pluginApiIdentifiers("group-chooser"), selectKitOptions({
  allowAny: false
}), classNames("group-chooser")]);
export default GroupChooser;